import { Dispatch } from 'redux';

import { fetcher, requestBot } from '../../lib/request';

export const AUTHORIZATION_REQUEST = 'AUTHORIZATION_REQUEST';
export const AUTHORIZATION_RESPONSE = 'AUTHORIZATION_RESPONSE';
export const AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR';

export const AUTHORIZATION_SEND_CODE_REQUEST = 'AUTHORIZATION_SEND_CODE_REQUEST';
export const AUTHORIZATION_SEND_CODE_RESPONSE = 'AUTHORIZATION_SEND_CODE_RESPONSE';
export const AUTHORIZATION_SEND_CODE_ERROR = 'AUTHORIZATION_SEND_CODE_ERROR';
export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_RESPONSE = 'REFRESH_TOKEN_RESPONSE';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';

export const RESET_AUTHORIZATION = 'AUTHORIZATION_RESET_AUTHORIZATION';
export const RESET_SEND_CODE_AUTHORIZATION = 'AUTHORIZATION_RESET_SEND_CODE_AUTHORIZATION';

export const authorizationAction = (phone: string, channelUserId: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: AUTHORIZATION_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/authorization`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
        body: JSON.stringify({
            phone: phone,
            channel_user_id: channelUserId,
        }),
    }).then(response => dispatch({
        type: AUTHORIZATION_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: AUTHORIZATION_ERROR,
        error,
    }));
};

export const authorizationSendCodeAction = (body: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: AUTHORIZATION_SEND_CODE_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/authorization/sendCode`, {
        method: 'POST',
        headers: new Headers({
            'Content-type': 'application/json',
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
        body,
    }).then(response => dispatch({
            type: AUTHORIZATION_SEND_CODE_RESPONSE,
            response,
        })).catch(error => dispatch({
        type: AUTHORIZATION_SEND_CODE_ERROR,
        error,
    }
    ));
};

export const refreshTokenAction = (userId?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REFRESH_TOKEN_REQUEST,
    });

    try {
        let body;
        if (!userId) {
            body = {
                grant_type: 'refresh_token',
                refresh_token: JSON.parse(localStorage.getItem('auth') as any).refresh_token,
            };
        } else {
            body = {
                grant_type: 'password',
                user_id: userId,
                phone: localStorage.getItem('phone'),
            };
        }
        const response = await fetcher(`${process.env.REACT_APP_BOT_REG_SERVER}/oauth/token`)
            .post(body)
            .auth(`Basic ${process.env.REACT_APP_BOT_KEY}`)
            .json();

        dispatch({
            type: REFRESH_TOKEN_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: REFRESH_TOKEN_ERROR,
            error,
        });
    }
};

export const resetAuthorizationAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_AUTHORIZATION,
});

export const resetSendCodeAuthorizationAction = () => (dispatch: Dispatch<any>) => dispatch({
    type: RESET_SEND_CODE_AUTHORIZATION,
});



// WEBPACK FOOTER //
// ./src/actions/Authorization/authorization.ts